import {
  GamepadAction,
  GamepadLayoutType,
  JOYSTICK_INPUT_LABEL_MAP,
  JoystickInput,
} from '@/providers';
import { capitalizeAndSplitOnUpperCase } from '@/utils';

export const getActionForInput = <L extends GamepadLayoutType, I extends JoystickInput>(
  layout: L,
  input: I
): GamepadAction | string => {
  const allSections = ['global', 'camera', 'winch'] as const;

  for (const section of allSections) {
    const mapping = layout[section] as Record<string, JoystickInput>;
    const found = Object.entries(mapping).find(([, value]) => value === input);

    if (found) return capitalizeAndSplitOnUpperCase(found[0]) as GamepadAction;
  }

  return capitalizeAndSplitOnUpperCase(JOYSTICK_INPUT_LABEL_MAP[input]).replace('.', ': '); // Fallback to input identifier if not mapped
};
